<template>
  <div>
    <div id="dim-filter-collapse"
         v-b-toggle.dim-filter-index-collapse
         class="m-1 ml-2 index-chip pointer bg-primary">
      <div class="text-center index-chip-left">{{indexDescription}}</div>
      <div class="text-center index-chip-right">
        {{indexMetric | numberAbb}}
      </div>
    </div>
    <b-tooltip target="dim-filter-collapse" triggers="hover">
      <h6> {{tooltipMsg}}</h6>
    </b-tooltip>

    <b-collapse id="dim-filter-index-collapse">
      <IndexFilter :filter-list="dimensionFilterData"/>
    </b-collapse>
  </div>

</template>

<script>
  import { DimensionUtils, GeneralUtils } from '@/mixins/index'
  import IndexFilter from './IndexFilter'
  import {reportParameters} from '../../library/requestParameters/generalKeyApiAnalysisRequestParameters'

  export default {
    name: 'DimensionFilter',
    mixins: [DimensionUtils, GeneralUtils],
    components: {
      IndexFilter
    },
    data () {
      return {
        indexDescription: '',
        indexMetric: '',
        indexFirstListItem: {},
        tooltipMsg: ''

      }
    },
    created () {
      this.$eventHub.$on('dimension-filter-fetch-data', this.fetchData)
    },
    beforeDestroy () {
      this.$eventHub.$off('dimension-filter-fetch-data')
    },
    watch: {
      vuexSelectedIndexItem (obj) {
        this.setTooltip(obj)
      }
    },
    computed: {
      vuexRetailSelected () {
        return this.$store.state.generalKeyKpiAnalysis.selectedRetail
      },
      vuexReportParameters () {
        return this.$store.state.generalKeyKpiAnalysis.reportParameters
      },
      vuexSelectedReport () {
        return this.$store.state.generalKeyKpiAnalysis.selectedReport
      },
      vuexSelectedIndexItem () {
        return this.$store.state.dimensionFilterQuickAccess.selectedIndexItem
      },
      gettersDefaultDimensionFilter () {
        return this.$store.getters.dimensionFilter
      },
      vuexFilterObjectActiveInstance () {
        let filterCopy = this.$store.state.filterRequestObject.activeFilterObjectInstance
        return this.$_generalUtils_deepJsonCopy(filterCopy)
      },
      dimensionFilterData () {
        return this.$_generalUtils_deepJsonCopy(this.$store.state.generalKeyKpiAnalysis.dimensionFilterData)
      }
    },
    methods: {
      setTooltip (obj) {
        this.indexDescription = this.vuexSelectedIndexItem.description
        this.indexMetric = this.vuexSelectedIndexItem.metric
        let tooltipObj = {
          description: obj.description,
          metric: this.$_numberNumeralFormat_2(obj.metric)
        }
        this.tooltipMsg = reportParameters[this.vuexSelectedReport].chipTooltip(tooltipObj)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/expertoRetail/components/DimensionFilterQuickAccess/DimensionFilterQuickAccess.vue